import React, { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

import { FileOutlined } from '@ant-design/icons';

import MyCollapse from 'components/Collapse';
import Spin from 'components/Spin';
import type { IFiscalDocuments, ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingService from 'v2/services/shopping/product';

const FiscalDocument = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [loadingDocuments, setLoadingDocument] = useState<boolean>(false);
  const [fiscalDocuments, setFiscalDocuments] = useState<any[]>([]);

  const handleClickFiscalDocuments = useCallback(async (invoiceId: string) => {
    setLoadingDocument(true);
    shoppingService.loadFiscalDocuments(invoiceId).subscribe(res => {
      setFiscalDocuments(res.data);
      setLoadingDocument(false);
    }, toast.error);
  }, []);

  return (
    <MyCollapse title='Nota Fiscal' onClick={() => handleClickFiscalDocuments(delivery.invoice_id.toString())} arrow>
      {loadingDocuments && <Spin />}

      {!loadingDocuments &&
        Array.isArray(fiscalDocuments) &&
        fiscalDocuments.length > 0 &&
        fiscalDocuments.map((document: IFiscalDocuments, index) => {
          return (
            <div key={'document-' + index}>
              <a
                href={document.url}
                target='_blank'
                rel='noopener noreferrer'
                className='text-content-subtitle flex items-center gap-2 text-sm'
              >
                <FileOutlined />
                <span>
                  {document.title} ({document.ext.toUpperCase()})
                </span>
              </a>
            </div>
          );
        })}

      {!loadingDocuments && (!Array.isArray(fiscalDocuments) || fiscalDocuments.length === 0) && (
        <div className='text-content-subtitle w-full py-4 text-center text-sm'>Nenhum arquivo encontrado...</div>
      )}
    </MyCollapse>
  );
};

export default FiscalDocument;
